var videoSections = document.querySelectorAll('section.video');

videoSections.forEach((container) => {
  var player;
  var playerId = container.id + '-player';
  var YTId = document.getElementById(playerId).dataset.id;
  container.addEventListener('click', () => {
    if (!document.getElementById('ytIframeApi')) {
      var tag = document.createElement('script');
      tag.id = 'ytIframeApi';
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
    player = new YT.Player(playerId, {
      height: '390',
      width: '640',
      videoId: YTId,
      playerVars: {
        playsinline: 1,
      },
      origin: window.location.origin,
      events: {
        onReady: onPlayerReady,
      },
    });
    function onPlayerReady(event) {
      event.target.playVideo();
    }
  });
  //   function onYouTubeIframeAPIReady() {}
});
